import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/layouts/Flex/flex';
import { formatBreakpointMods } from '../../helpers/util';
export var Flex = function Flex(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      spacer = _a.spacer,
      spaceItems = _a.spaceItems,
      grow = _a.grow,
      shrink = _a.shrink,
      flex = _a.flex,
      direction = _a.direction,
      alignItems = _a.alignItems,
      alignContent = _a.alignContent,
      alignSelf = _a.alignSelf,
      align = _a.align,
      justifyContent = _a.justifyContent,
      display = _a.display,
      fullWidth = _a.fullWidth,
      flexWrap = _a.flexWrap,
      props = __rest(_a, ["children", "className", "spacer", "spaceItems", "grow", "shrink", "flex", "direction", "alignItems", "alignContent", "alignSelf", "align", "justifyContent", "display", "fullWidth", "flexWrap"]);

  return React.createElement("div", Object.assign({
    className: css(styles.flex, formatBreakpointMods(spacer, styles), formatBreakpointMods(spaceItems, styles), formatBreakpointMods(grow, styles), formatBreakpointMods(shrink, styles), formatBreakpointMods(flex, styles), formatBreakpointMods(direction, styles), formatBreakpointMods(alignItems, styles), formatBreakpointMods(alignContent, styles), formatBreakpointMods(alignSelf, styles), formatBreakpointMods(align, styles), formatBreakpointMods(justifyContent, styles), formatBreakpointMods(display, styles), formatBreakpointMods(fullWidth, styles), formatBreakpointMods(flexWrap, styles), className)
  }, props), children);
};